module.exports = __webpack_public_path__ + "img/starFilled.eeb1f069.svg";